import React from 'react';
import { motion } from 'framer-motion';
import { galleryImages } from '../data/siteContent';

const Gallery = () => {
  return (
    <section className="gallery-section">
      <div className="container">
        <div className="centers-heading">
          <span className="section-kicker">Real center moments</span>
          <h2 className="section-title">Photo Gallery</h2>
          <p className="centers-disclaimer">
            Clinic, consultation, and patient-care images shown without cropping so each photo keeps its
            natural proportions.
          </p>
        </div>

        <motion.div
          className="award-gallery-grid"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
        >
          {galleryImages.map((image, index) => (
            <motion.figure
              key={`${image.alt}-${index}`}
              className="award-gallery-item"
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: index * 0.04 }}
            >
              <img src={image.src} alt={image.alt} />
            </motion.figure>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Gallery;
